(function () {
  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function fitThumbsColumn(gallery) {
    const list = gallery.querySelector('.zerra-pdp__thumbs');
    const stage = gallery.querySelector('.zerra-pdp__stage');
    if (!list || !stage) return;
    if (window.matchMedia('(max-width: 749px)').matches) {
      list.style.removeProperty('--zerra-thumb-size');
      list.style.removeProperty('max-height');
      return;
    }

    const items = list.querySelectorAll(':scope > li');
    const n = items.length;
    if (!n) return;

    list.style.removeProperty('--zerra-thumb-size');
    list.style.removeProperty('max-height');

    const styles = window.getComputedStyle(list);
    const gap = parseFloat(styles.rowGap || styles.gap) || 8;
    const colW = list.getBoundingClientRect().width;
    const maxH = stage.getBoundingClientRect().height;
    if (!colW || !maxH) return;

    list.style.maxHeight = `${Math.round(maxH)}px`;

    const needed = n * colW + (n - 1) * gap;
    const size = needed <= maxH + 0.5 ? colW : Math.max(44, (maxH - (n - 1) * gap) / n);
    list.style.setProperty('--zerra-thumb-size', `${Math.floor(size * 100) / 100}px`);
  }

  function initGallery(root) {
    const gallery = root.querySelector('[data-zerra-gallery]');
    if (!gallery || gallery.dataset.ready === 'true') return;
    gallery.dataset.ready = 'true';

    const main = gallery.querySelector('[data-zerra-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-zerra-gallery-thumb]'));
    const prev = gallery.querySelector('[data-zerra-gallery-prev]');
    const next = gallery.querySelector('[data-zerra-gallery-next]');
    const currentEl = gallery.querySelector('[data-zerra-gallery-current]');
    const totalEl = gallery.querySelector('[data-zerra-gallery-total]');

    const scheduleFit = () => {
      window.requestAnimationFrame(() => fitThumbsColumn(gallery));
    };
    scheduleFit();
    window.addEventListener('resize', scheduleFit, { passive: true });
    if (main) {
      if (main.complete) scheduleFit();
      else main.addEventListener('load', scheduleFit, { once: true });
    }

    if (!main) return;
    if (!thumbs.length) {
      if (totalEl) totalEl.textContent = pad2(1);
      if (currentEl) currentEl.textContent = pad2(1);
      return;
    }

    let index = thumbs.findIndex(
      (t) => t.classList.contains('is-active') || t.getAttribute('aria-current') === 'true'
    );
    if (index < 0) index = 0;
    if (totalEl) totalEl.textContent = pad2(thumbs.length);
    if (currentEl) currentEl.textContent = pad2(index + 1);

    const setActive = (btn, i) => {
      const src = btn.getAttribute('data-full-src');
      const srcset = btn.getAttribute('data-full-srcset');
      const alt = btn.getAttribute('data-alt') || '';
      if (!src) return;
      index = typeof i === 'number' ? i : thumbs.indexOf(btn);
      main.style.opacity = '0.55';
      main.style.transform = 'scale(0.98)';
      window.setTimeout(() => {
        main.src = src;
        if (srcset) main.srcset = srcset;
        main.alt = alt;
        main.style.opacity = '1';
        main.style.transform = 'scale(1)';
        scheduleFit();
      }, 120);
      thumbs.forEach((t, ti) => {
        const on = t === btn;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && currentEl) currentEl.textContent = pad2(ti + 1);
      });
    };

    thumbs.forEach((btn, i) => {
      btn.addEventListener('click', () => setActive(btn, i));
    });

    prev?.addEventListener('click', () => {
      const nextIndex = (index - 1 + thumbs.length) % thumbs.length;
      setActive(thumbs[nextIndex], nextIndex);
    });
    next?.addEventListener('click', () => {
      const nextIndex = (index + 1) % thumbs.length;
      setActive(thumbs[nextIndex], nextIndex);
    });
  }

  function moneyMap(root) {
    const node = root.querySelector('[data-zerra-pdp-money]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  }

  function variantsData(root) {
    const node = root.querySelector('[data-zerra-pdp-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return [];
    }
  }

  function initVariants(root) {
    const buy = root.querySelector('[data-zerra-pdp]');
    if (!buy || buy.dataset.variantsReady === 'true') return;
    buy.dataset.variantsReady = 'true';

    const variants = variantsData(root);
    const money = moneyMap(root);
    const idInput = root.querySelector('[data-zerra-variant-id]');
    const priceEl = root.querySelector('[data-zerra-price]');
    const compareEl = root.querySelector('[data-zerra-compare]');
    const submit = root.querySelector('[data-zerra-submit]');
    const optionInputs = Array.from(root.querySelectorAll('[data-zerra-option]'));

    if (!variants.length || !idInput) return;

    const selectedOptions = () => {
      const map = {};
      optionInputs.forEach((input) => {
        if (input.checked) map[input.dataset.optionPosition] = input.value;
      });
      return map;
    };

    const findVariant = () => {
      const selected = selectedOptions();
      return variants.find((variant) =>
        variant.options.every((opt, i) => selected[String(i + 1)] === opt)
      );
    };

    const sync = () => {
      const variant = findVariant() || variants.find((v) => v.available) || variants[0];
      if (!variant) return;

      idInput.value = variant.id;
      idInput.disabled = !variant.available;

      if (priceEl && money[variant.id]) {
        priceEl.textContent = money[variant.id].price;
      }
      if (compareEl) {
        if (money[variant.id]?.compare && money[variant.id].compare_raw > variant.price) {
          compareEl.textContent = money[variant.id].compare;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (submit) {
        const label = submit.querySelector('.zerra-led-btn__label');
        if (!variant.available) {
          submit.setAttribute('disabled', 'disabled');
          if (label) label.textContent = submit.dataset.soldOutLabel || 'Esaurito';
        } else {
          submit.removeAttribute('disabled');
          if (label) label.textContent = submit.dataset.addLabel || 'Aggiungi al carrello';
        }
      }

      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId) {
        const thumb = root.querySelector(`[data-zerra-gallery-thumb][data-media-id="${mediaId}"]`);
        if (thumb) thumb.click();
      }
    };

    optionInputs.forEach((input) => input.addEventListener('change', sync));
    sync();
  }

  function initQty(root) {
    root.querySelectorAll('[data-zerra-qty]').forEach((wrap) => {
      if (wrap.dataset.ready === 'true') return;
      wrap.dataset.ready = 'true';
      const input = wrap.querySelector('input');
      const minus = wrap.querySelector('[data-zerra-qty-minus]');
      const plus = wrap.querySelector('[data-zerra-qty-plus]');
      if (!input) return;

      const clamp = () => {
        const min = Number(input.min || 1);
        const max = Number(input.max || 99);
        let val = parseInt(input.value, 10);
        if (Number.isNaN(val) || val < min) val = min;
        if (val > max) val = max;
        input.value = String(val);
      };

      minus?.addEventListener('click', () => {
        input.value = String(Math.max(Number(input.min || 1), (parseInt(input.value, 10) || 1) - 1));
        clamp();
      });
      plus?.addEventListener('click', () => {
        input.value = String(Math.min(Number(input.max || 99), (parseInt(input.value, 10) || 1) + 1));
        clamp();
      });
      input.addEventListener('change', clamp);
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-zerra-pdp-tabs]').forEach((wrap) => {
      if (wrap.dataset.ready === 'true') return;
      wrap.dataset.ready = 'true';
      const tabs = Array.from(wrap.querySelectorAll('[data-zerra-tab]'));
      const panels = Array.from(wrap.querySelectorAll('[data-zerra-panel]'));

      const activate = (id) => {
        tabs.forEach((tab) => {
          const on = tab.getAttribute('data-zerra-tab') === id;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const on = panel.getAttribute('data-zerra-panel') === id;
          panel.classList.toggle('is-active', on);
          panel.hidden = !on;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab.getAttribute('data-zerra-tab')));
      });
    });
  }

  function boot(root = document) {
    root.querySelectorAll('.zerra-pdp').forEach((section) => {
      initGallery(section);
      initVariants(section);
      initQty(section);
      initTabs(section);
    });
    if (window.initZerraLedButtons) window.initZerraLedButtons(root);
  }

  document.addEventListener('DOMContentLoaded', () => boot());
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  if (document.readyState !== 'loading') boot();
})();
